import React from 'react'
import { useTranslation } from 'react-i18next'
import CustomModal from '../../Elements/modal/CustomModal'
import { DrawerContent, StateHeading, StateSubtext } from './index.styled'
import { DRAWER_ID } from './helper'
import { usePairing } from './usePairing'
import StateIcon from './StateIcon'
import CodeView from './CodeView'
import DeviceInfo from './DeviceInfo'
import FooterButton from './FooterButton'

const TITLES = {
	connecting: 'watch.connecting.title',
	connected: 'watch.connected.title',
	'delete-confirm': 'watch.deleteConfirm.title',
	deleting: 'watch.deleting.title',
	deleted: 'watch.deleted.title'
}

const MESSAGES = {
	'not-connected': { heading: 'watch.connect.heading', subtext: 'watch.connect.subtext', headingTestId: 'heading-not-connected' },
	generating: { heading: 'watch.generating.heading', subtext: 'watch.generating.subtext' },
	connecting: { heading: 'watch.connecting.heading', subtext: 'watch.connecting.subtext' },
	connected: { heading: 'watch.connected.heading', subtext: 'watch.connected.subtext', headingTestId: 'heading-connected' },
	'delete-confirm': { heading: 'watch.deleteConfirm.heading', subtext: 'watch.deleteConfirm.subtext' },
	deleting: { heading: 'watch.deleting.heading', subtext: 'watch.deleting.subtext' },
	deleted: { heading: 'watch.deleted.heading', subtext: 'watch.deleted.subtext' }
}

const FOOTERLESS = ['generating', 'connecting', 'deleting']

const WatchPairingDrawer = () => {
	const { t } = useTranslation()
	const { drawerOpen, drawerState, pairingCode, timeLeft, watch, handlers } = usePairing()

	if (!drawerOpen) return null

	const message = MESSAGES[drawerState]

	return (
		<CustomModal
			id={DRAWER_ID}
			isOpen={drawerOpen}
			close={handlers.close}
			title={t(TITLES[drawerState] || 'watch.connect.title')}
			footerClassname="center"
			zIndex={5}
			disableBackButton={true}
			enableOutsideClick={false}
			size="small">
			<DrawerContent>
				{drawerState === 'code'
					? <CodeView code={pairingCode} timeLeft={timeLeft} onCopy={handlers.copyCode} />
					: message &&
						<>
							<StateIcon state={drawerState} />
							<StateHeading data-testid={message.headingTestId}>{t(message.heading)}</StateHeading>
							<StateSubtext>{t(message.subtext)}</StateSubtext>
							{drawerState === 'connected' && <DeviceInfo watch={watch} />}
						</>}
				{!FOOTERLESS.includes(drawerState) && <FooterButton state={drawerState} handlers={handlers} />}
			</DrawerContent>
		</CustomModal>
	)
}

WatchPairingDrawer.displayName = 'WatchPairingDrawer'
export default WatchPairingDrawer
